import { useEffect, useState } from 'react'
import { getTranslation } from 'helpers/translations.helpers'
import './RotateDeviceOverlay.scss'

const PORTRAIT_QUERY = '(orientation: portrait) and (max-width: 1024px)'

/**
 * Landscape-only game: block play on phone/tablet portrait and ask to rotate.
 */
const RotateDeviceOverlay = () => {
  const [showOverlay, setShowOverlay] = useState(false)

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return undefined

    const media = window.matchMedia(PORTRAIT_QUERY)
    const sync = () => setShowOverlay(media.matches)

    sync()
    if (media.addEventListener) {
      media.addEventListener('change', sync)
      return () => media.removeEventListener('change', sync)
    }
    media.addListener(sync)
    return () => media.removeListener(sync)
  }, [])

  if (!showOverlay) return null

  return (
    <div className='rotate-device-overlay' role='alertdialog' aria-live='assertive' aria-modal='true'>
      <div className='rotate-device-overlay__content'>
        <div className='rotate-device-overlay__phone' aria-hidden='true'>
          <div className='rotate-device-overlay__phone-body'>
            <div className='rotate-device-overlay__phone-screen' />
          </div>
          <svg className='rotate-device-overlay__arrow' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M8 24c0-8.837 7.163-16 16-16 5.523 0 10.419 2.804 13.314 7.077'
              stroke='currentColor'
              strokeWidth='3'
              strokeLinecap='round'
            />
            <path d='M40 8v10H30' stroke='currentColor' strokeWidth='3' strokeLinecap='round' strokeLinejoin='round' />
          </svg>
        </div>
        <p className='rotate-device-overlay__title'>
          {getTranslation('PleaseRotateYourDevice')}
        </p>
        <p className='rotate-device-overlay__subtitle'>
          {getTranslation('PleaseRotateYourDeviceHint')}
        </p>
      </div>
    </div>
  )
}

export default RotateDeviceOverlay
